import qweBaseField from "../BaseField"
import { JSONReplacer, qweIsEmpty } from "../../../common/commonHelper"
import { DefaultValueType } from "../../../common/constant"
import { getGroupResultByKey } from "../../../apis/httpHelper"

export default {
    mixins :[qweBaseField],
    data: function () {
        return {
            autocomplete: false,
            showWordLimit: false,
            minLength: 0,
            maxLength: 999,
            placeHolder:""
        };
    },
    created: function () {
        this.autocomplete = this.selfSetting.IsAutocomplete;
        this.showWordLimit = this.selfSetting.SizeInfo.ShowWordLimit;
        if(this.showWordLimit){
            this.minLength = this.selfSetting.SizeInfo.MinLength;
            this.maxLength = this.selfSetting.SizeInfo.MaxLength;
        }
        this.placeHolder = this.selfSetting.Placeholder;
    },

    methods:{
        subSetRules: function () {
            let format = this.selfSetting.StringTypeValue;
            if (format === 3) {
                this.rules.push({ pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/, message: '您的邮箱格式不正确', trigger: 'blur' });
            } else if (format === 4) {
                this.rules.push({ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '您的身份证格式不正确', trigger: 'blur' });
            } else if (format === 1) {
                this.rules.push({ pattern: /^1[3456789]\d{9}$/, message: '您的手机号码不正确', trigger: 'blur' });
            } else if (format === 2) {
                this.rules.push({ pattern: /^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/, message: '固定电话格式不正确', trigger: 'blur' });
            }

            if(this.selfSetting.SizeInfo.ShowWordLimit){
                this.rules.push({
                    type: 'string',
                    min:this.selfSetting.SizeInfo.MinLength,
                    max:this.selfSetting.SizeInfo.MaxLength,
                    message: this.displayName + "的内容长度在" + this.selfSetting.SizeInfo.MinLength+ "-" + this.selfSetting.SizeInfo.MaxLength+"范围之外",
                })
            }
        },

        search: function (queryString, cb) {
            let that = this;
            if (qweIsEmpty(queryString)) {
                return;
            }
            let requestData = {};
            let computedRequestData = {};

            if (this.fieldValueSetting.DefaultValueType == DefaultValueType.DataLinkage) {
                computedRequestData = this.computedRequestData();
                if (computedRequestData.logic === "And") {
                    computedRequestData.filters.push({
                        "field": that.selfSetting.AutocompleteInfo.FieldName,
                        "operator": "contains",
                        "value": queryString
                    });
                    requestData = computedRequestData;
                }
                else {
                    requestData = {
                        "logic": "And",
                        "filters": [{
                            "field": that.selfSetting.AutocompleteInfo.FieldName,
                            "operator": "contains",
                            "value": queryString
                        }, computedRequestData]
                    };
                }
            }

            requestData = {
                "logic": "And",
                "filters": [{
                    "field": that.selfSetting.AutocompleteInfo.FieldName,
                    "operator": "contains",
                    "value": queryString
                }]
            };
            
            getGroupResultByKey(this.selfSetting.AutocompleteInfo.ContentType,
                JSON.stringify(requestData,JSONReplacer),
                this.selfSetting.AutocompleteInfo.FieldName
            ).then(x=>{
                let data = x.Result;
                cb(data.map(x => { return { "value": x }; }));
            }).catch(x=>{
                console.log(this.displayName + "-" +this.name + "配置异常");
                console.log(x);
            });
        } 
    }
}